import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { fieldToTextField } from "formik-material-ui";
import { IntlNumberField } from "./helpers/IntlNumberField";
import { useFormikValueOnChange } from "./hooks";
import { identityRecordOfFieldEditorOptions, getFieldError } from "./utils";
const useFieldToIntlNumberField = ({ items, getItemValue, getItemLabel, valueKey, labelKey, getItemSuggestions, onSelectItem, manual, horizontal: row, multiple, pending, options, formatString, italicText, boldText, errorDisplay, modalText, onBlur: propsBlur, onChange: nativeOnChange, ...props }) => {
    const onChange = useFormikValueOnChange(props);
    const { field, form: { errors, touched } } = props;
    const numberProps = fieldToTextField(props);
    const { onBlur: formikBlur } = numberProps;
    const onBlur = useCallback((e) => {
        if (formikBlur)
            formikBlur(e);
        if (propsBlur)
            propsBlur(e);
    }, [formikBlur, propsBlur]);
    return {
        ...numberProps,
        ...getFieldError(errors, touched, field.name, errorDisplay),
        onChange,
        onBlur,
        nativeOnChange,
        formatString,
        maxLength: options?.maxLength,
        value: typeof numberProps.value === "number"
            ? numberProps.value
            : Number(numberProps.value)
    };
};
export function CurrencyField(props) {
    const numberProps = useFieldToIntlNumberField(props);
    return _jsx(IntlNumberField, { format: "currency_input", ...numberProps });
}
export function PercentField(props) {
    const numberProps = useFieldToIntlNumberField(props);
    return _jsx(IntlNumberField, { format: "percent_input", ...numberProps });
}
export function NumberField(props) {
    const numberProps = useFieldToIntlNumberField(props);
    return _jsx(IntlNumberField, { ...numberProps });
}
export function CustomField(props) {
    const numberProps = useFieldToIntlNumberField(props);
    return _jsx(IntlNumberField, { format: "", ...numberProps });
}
const commonOptions = {
    editableOptions: {
        placeholder: true,
        suffix: true,
        allowNegative: true,
        maximumFractionDigits: true,
        emptyEqualsZeroHandling: true
    }
};
export const EditorNumberFields = identityRecordOfFieldEditorOptions({
    CurrencyField: commonOptions,
    PercentField: commonOptions,
    NumberField: commonOptions
});
//# sourceMappingURL=NumberFields.js.map